import {CacheProvider, type EmotionCache} from '@emotion/react';
import type {FC, PropsWithChildren} from 'react';

import {createEmotionCache} from '@/lib/emotion';
import {DialogControllerProvider, TippyProvider, TooltipProvider} from '@isudio/ui';

type Props = PropsWithChildren<{
  emotionCache?: EmotionCache;
}>;

const clientSideEmotionCache = createEmotionCache();

export const AppProviders: FC<Props> = (props) => {
  const {
    children,
    emotionCache = clientSideEmotionCache
  } = props;
  return (
    <CacheProvider
      value={emotionCache}>
      <TippyProvider>
        <TooltipProvider>
          <DialogControllerProvider>
            {children}
          </DialogControllerProvider>
        </TooltipProvider>
      </TippyProvider>
    </CacheProvider>
  );
};
